// components/Loader.js
import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "var(--white-color)",
        backdropFilter: " blur(1px)"
      }}
    >
<div class="loader">
    <span>WeekMate</span>
    <span>WeekMate</span>
</div>
    </div>
  );
};

export default Loader;
